var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPipedrive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.8797 16.9393C16.8797 19.3224 18.1674 21.8692 20.9905 21.8692C23.0707 21.8692 25.2004 20.3505 25.2251 16.8925C25.2251 13.8785 23.5412 11.8692 21.0648 11.8692C19.0341 11.8692 16.8797 13.2009 16.8797 16.9393Z",
    fill: "#203232"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 0C3.58172 0 0 3.58172 0 8V32C0 36.4183 3.58172 40 8 40H32C36.4183 40 40 36.4183 40 32V8C40 3.58172 36.4183 0 32 0H8ZM16.5825 9.6028C17.3997 8.76168 19.1084 7.5 22.0553 7.5C27.1072 7.5 30.5246 11.2617 30.4999 16.8458C30.4999 22.3598 26.9091 26.1916 21.7829 26.1916C19.3313 26.1916 17.7712 25.2103 16.954 24.5093V32.5H11.704V12.6168C11.704 12.3364 11.6049 12.243 11.3078 12.243H9.5V7.8972H13.9328C15.9634 7.8972 16.4834 8.85514 16.5825 9.6028Z",
    fill: "#203232"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPipedrive);
export default __webpack_public_path__ + "static/media/pipedrive.85e6e69411523264babbf85e1f2d85c4.svg";
export { ForwardRef as ReactComponent };